import queries from '@apis/queries';
import { AppCustomResponse } from '@models/custom';
import AppCustomContext from '@providers/AppCustomProvider/context/AppCustomContext';
import { useQuery } from '@tanstack/react-query';
import { ReactNode, useEffect, useState } from 'react';

import defaultCustomProps from './constants/defaultCustomProps';

interface Props {
    children?: ReactNode;
}

function AppCustomProvider({ children }:Props) {
    const [state, setState] = useState<AppCustomResponse>(defaultCustomProps);
    const { data } = useQuery(queries.appCustom.detail());
    useEffect(() => {
        if (data) {
            setState(data);
        }
    }, [data]);
    return (
        <AppCustomContext value={{ response: state }}>
            {children}
        </AppCustomContext>
    );
}

export default AppCustomProvider;
